import React from 'react';
import PropTypes from "prop-types";
import './BlockHeader.less';
import {Badge} from "antd";

const BlockHeader = (props) => {
    return (
        <div className={'BlockHeader' + (props.className == null ? '' : ' ' + props.className)}>
            <Badge className='BlockHeaderBadge' status={props.status}/>
            <span className='BlockHeaderText'>{props.text}</span>
        </div>
    );
}

BlockHeader.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['default', 'processing', 'success', 'error', 'warning']),
};
BlockHeader.defaultProps = {
    status: 'default',
}

export default BlockHeader;